import { useContext, useState } from 'react';
import MyOffersCard from './Components/MyOffersCard';
import Carousel from './Components/Carousel/Carousel';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { TargetedOffersContext } from 'contexts/TargetedOffersContext';
import { COUPON } from 'contexts/CruiseSearchContext/constants';
import {
  sliderContainerStyles,
  rootStyles,
  wrapperStyles,
  infoStyles,
  itemContainerStyles,
  nextButtonStyles,
  prevButtonStyles,
} from './Components/Carousel/Carousel.styled';
import classNames from 'classnames';

const MyOffers = () => {
  // eslint-disable-next-line no-unused-vars
  const {
    targetedOffers,
    targetedOfferApplied,
    targetedOfferSelected,
    removeFromQualifiersSelecting,
  } = useContext(CruiseSearchContext);

  const { removeTargetedOfferSelected, selectTargetedOffer } = useContext(TargetedOffersContext);

  const [active, setActive] = useState(targetedOfferApplied);
  const [isPrevArrowShown, setIsPrevArrowShown] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
  const [prevButtonDisabled, setPrevButtonDisabled] = useState(false);

  function showIndicators(args) {
    const { isDesktop } = args;
    return !isDesktop;
  }

  function showNextArrow(args) {
    const { isDesktop, active: itemActive, length: itemsLength } = args;
    const atEnd = itemActive >= itemsLength - 1;
    setNextButtonDisabled(atEnd);
    return !atEnd && isDesktop;
  }

  function showPrevArrow(args) {
    const { isDesktop, active: itemActive } = args;
    const atStart = itemActive === 0;
    setPrevButtonDisabled(atStart);
    setIsPrevArrowShown(!atStart && isDesktop);
    return !atStart && isDesktop;
  }

  const carouselClasses = {
    root: classNames({ isPrevArrowShown }),
    nextButton: classNames({ disabled: nextButtonDisabled }),
    prevButton: classNames({ disabled: prevButtonDisabled }),
  };

  const carouselStyles = {
    sliderContainer: sliderContainerStyles,
    root: rootStyles,
    wrapper: wrapperStyles,
    info: infoStyles,
    itemContainer: itemContainerStyles,
    nextButton: nextButtonStyles,
    prevButton: prevButtonStyles,
  };

  const getIndex = (prefix, index) => `${prefix}-${index}`;

  return (
    <Carousel
      id="targetedOffersCarousel"
      showIndicators={showIndicators}
      showNextArrow={showNextArrow}
      showPrevArrow={showPrevArrow}
      carouselClasses={carouselClasses}
      carouselStyles={carouselStyles}
      items={targetedOffers.map((offer, index) => (
        <MyOffersCard
          onClick={() => {
            if (offer.couponCode === targetedOfferSelected.couponCode) {
              setActive({});
              removeTargetedOfferSelected();
              removeFromQualifiersSelecting(`${COUPON}:${offer.couponCode}`);
            } else {
              setActive(offer);
              selectTargetedOffer(offer);
            }
          }}
          active={active.campaignId === offer.campaignId}
          applied={targetedOfferApplied.campaignId === offer.campaignId}
          disabled={false}
          key={getIndex(offer.campaignId, index)}
          targetedOffer={offer}
        />
      ))}
    />
  );
};

export default MyOffers;
